import("./loading.styles.css");

export default function Loading() {
    return (
        <div className="loading-main">
            <i className="fas fa-spinner fa-4x"></i>
        </div>
    )
}